import React, { useState, useEffect } from "react";

// redux
import { useDispatch, useSelector } from "react-redux";
import { selectBookingSearch, selectTaskStatusFilter, selectTimelineData } from "_redux/slices/timeline/timeline-data";
import { selectTimelineDate } from "_redux/slices/timeline/timeline-control";

// styling
import "./job-list.css"
import ThirtyMinLayoutJobCard from "./thirtyMin-layout-job-card";
import JobCard from "./job-card";
import { selectOutboundFlights } from "_redux/slices/timeline/flight-information-list";


const ThirtyMinLayoutJobList = (props) => {


    const timelineData = useSelector(selectTimelineData);
    const bookingSearch = useSelector(selectBookingSearch);
    const taskStatusFilter = useSelector(selectTaskStatusFilter);
    const timelineDate = useSelector(selectTimelineDate);                                 // select timeline Date
    const outboundFlights = useSelector(selectOutboundFlights);

    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        let employeeId = props.employeeId;
        let hour = props.hour;

        let columnJobs = timelineData.columns[hour].jobs;
        let employeeJobs = columnJobs.filter((job) => job.employeeId == employeeId);

        if (employeeJobs.length > 0) {
            employeeJobs = filterTasks(employeeJobs);
            let interval = props.interval;
            let temp = [];

            // only add jobs within this interval to the job list
            employeeJobs.forEach((job) => {
                let jobTime = job.assignedTime
                let correctInterval = getIntervalForTime(jobTime);

                // check if interval of assigned time matches with the interval of the column
                if (correctInterval == interval) {

                    temp.push(job);
                }
            })

            // check if 
            setJobs(temp);

        } else {
            setJobs([]);
        }
    }, [timelineData, bookingSearch, taskStatusFilter, timelineDate]);

    // takes a time string and returns back the correct interval number
    const getIntervalForTime = (time) => {
        const [hours, minutes] = time.split(':').map(Number);

        // Calculate the minute offset within the half-hour block
        const offset = minutes % 30;

        // Calculate the interval number (5 minutes per interval)
        const interval = Math.floor(offset / 5);

        return interval;
    };

    // filter tasks list by it's status 
    const filterTasks = (tasks) => {
        let tempTasks = [...tasks];
        if (!taskStatusFilter || taskStatusFilter === "all") return tempTasks;
        switch (taskStatusFilter) {
            case "assigned":
                return tempTasks = tempTasks?.filter((task) => task?.active !== true && task?.completed !== true && task?.cancelled !== true && task?.stopped !== true);
            case "active":
                return tempTasks = tempTasks?.filter((task) => task?.active === true);
            case "complete":
                return tempTasks = tempTasks?.filter((task) => task?.completed === true);
            case "cancelled":
                return tempTasks = tempTasks?.filter((task) => task?.cancelled === true);
            case "stopped":
                return tempTasks = tempTasks?.filter((task) => task?.stopped === true);
            default:
                return tempTasks;
        }
    }

    return (
        Array.isFullArray(jobs) &&
        <div>
            {jobs.map((job, index) => (
                <JobCard
                    job={job}
                    index={index}
                    disabled={props?.disabled}
                    thirtyMinLayout={true}
                    outboundFlights={Array.isFullArray(outboundFlights) ? outboundFlights : []}
                    position={'absolute'}
                />
            ))}
        </div>
    );
};

export default ThirtyMinLayoutJobList;
